import DPSwitch from "framework/components/DPSwitch"
import React from "react"
import { CardText, Col, Row, Alert, Label } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"


const VendorMasterTab4 = ({
  fieldManager,
  intOutletDirect,
  SwonActiveChange,
  disabled,
  intOrderCycleValue,
  intOrderCycleonChange,
  strOrderGroupValue,
  strOrderGrouponChange,
  show,
  AlertColor,
  AlertMsg,
  ErrorMsg,
  setCreditPeriodOnBlur,
  CreditPeriodValue,
  setCreditPeriodOnchange,
  setCreditLimitOnBlur,
  CreditLimitValue,
  setCreditLimitOnchange
}) => {
  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                  <br />
                  <small>{ErrorMsg}</small>
                </Alert>
              ) : null}
              <Row>
                <Col sm={12} md={5} className="mb-4-sm">

                  <div style={{ display: "flex" }} hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_OUTDIRECT')}>
                    <Col sm={12} md={4} className="mb-4-sm">
                      <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                      >
                        Outlet direct purchasing
                      </Label>
                    </Col>
                    <Col sm={12} md={3} className="mb-4-sm">
                      <DPSwitch
                        rowClass="mb-4-sm"
                        labelText="Status"
                        textType="checkbox"
                        onChange={SwonActiveChange}
                        checked={intOutletDirect}
                        disabled={disabled || fieldManager.disable.includes('SM_OUTDIRECT')}
                      />
                    </Col>
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_ORDCYCLE')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Order cycle in days"
                      textType="text"
                      maxLength="4"
                      textAlign="right"
                      value={intOrderCycleValue}
                      onChange={intOrderCycleonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_ORDCYCLE')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_ORDGROUP')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Order group"
                      textType="text"
                      maxLength="5"
                      value={strOrderGroupValue}
                      onChange={strOrderGrouponChange}
                      disabled={disabled || fieldManager.disable.includes('SM_ORDGROUP')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_CRDPERIOD')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Credit period"
                      textType="text"
                      maxLength="18"
                      textAlign="right"
                      value={CreditPeriodValue}
                      onBlur={setCreditPeriodOnBlur}
                      onChange={setCreditPeriodOnchange}
                      disabled={disabled || fieldManager.disable.includes('SM_CRPERIOD')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_CRDLIMIT')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Credit limit"
                      textType="text"
                      maxLength="18"
                      textAlign="right"
                      value={CreditLimitValue}
                      onBlur={setCreditLimitOnBlur}
                      onChange={setCreditLimitOnchange}
                      disabled={disabled || fieldManager.disable.includes('SM_CRLIMIT')}
                    />
                  </div>
                </Col>

              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default VendorMasterTab4
